export default "__VITE_ASSET__9a698e51__"